















































import { Component, Prop, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import CancelJobWorkerInterviewRequest from '@/models/JobWorkerInterviews/CancelJobWorkerInterviewRequest';
import JobWorkerInterviewDto from '@/models/JobWorkerInterviews/JobWorkerInterviewDto';
import ListUtils from '@/lib/listUtils';

@Component({
    name: 'JobWorkerInterviewStatusSetCancelled'
})
export default class extends GiganautVueDialog {
 
  @Prop({required: true})
  jobWorkerInterview: JobWorkerInterviewDto;
  request: CancelJobWorkerInterviewRequest = new CancelJobWorkerInterviewRequest();

  get job() {
    return JobDetailsModule.currentJob;
  }

  @Watch("dialog")
  async dialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.request = new CancelJobWorkerInterviewRequest();
    } 
    this.$emit("closeMenu");
  }

  get cancelledReasons() {
    return ListUtils.jobWorkerInterviewCancelledReasons();
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    this.request.jobWorkerInterviewId = this.jobWorkerInterview.id;
    this.request.updatedAt = this.jobWorkerInterview.updatedAt;
    await JobDetailsModule.cancelJobWorkerInterview(this.request);
    this.dialog = false;
  }
}
